export default class DtoPicture {
    constructor(obj) {
        this.id = obj.id
        this.name = obj.name
        this.url = obj.url
    }
}